import React from "react";
import { useSearchParams } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const linkCards = [
  {
    title: "Book a Chat",
    description: "Schedule in a call to continue the conversation.",
    icon: "/assets/images/calendar.png",
    url: "https://outlook.office.com/book/AriaGraceLawIntroduction@aria-grace.com/?ismsaljsauthenabled"
  },
  {
    title: "Connect on LinkedIn",
    description: "Let’s stay connected on LinkedIn.",
    icon: "/icons/linkedin.svg",
    url: "https://www.linkedin.com/in/ezana-t-haddis-424772145/"
  },
  {
    title: "Chat on WhatsApp",
    description: "Message and I’ll get right back to you.",
    icon: "/assets/images/whatsapp.svg",
    url: "https://wa.me/447958793608?text=Hi Ezana - I'm interested in Aria Grace!"
  },
  {
    title: "View our Proposal",
    description: "Explore the value we bring to every client.",
    icon: "/assets/images/proposal.png",
    url: "https://www.aria-grace.com/about"
  }
];

const user_details = {
  full_name: "Ezana Haddis",
  position: "Chief Operating Officer",
  company_logo: "https://www.mydatapulse.co.uk/assets/images/aria_grace_logo.png",
  company_url: "https://www.aria-grace.com/"
}

function DigitalCard() {
  const [searchParams] = useSearchParams();
  const firstName = searchParams.get("first_name");
  const title = firstName ? `Great talking with you, ${firstName}` : "Great talking with you";
  return (
    <>
      <ScrollToTop/>

      <head>
        <title>{title} | Aria Grace Law CIC</title>
        <meta name="robots" content="noindex, nofollow" />
      </head>

      <Helmet>

          <meta name="robots" content="index, follow"/>

          <title>Aria Grace Law CIC | Digital Connect by DataPulse AI</title>
          <meta name="robots" content="index, follow" />
          <meta name="description" content="At Aria Grace Law CIC, we offer high-quality legal services with a focus on innovation and purpose." />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="author" content="DataPulse AI" />

          <meta property="og:title" content="Digital Connect | Aria Grace Law CIC" />
          <meta property="og:description" content="At Aria Grace Law CIC, we offer high-quality legal services with a focus on innovation and purpose." />
          <meta property="og:url" content="https://www.mydatapulse.co.uk/aria-grace/ezana" />
          <meta property="og:type" content="website" />
          <meta name="twitter:title" content="Digital Connect | Aria Grace Law CIC" />

          {/* Structured Data: Organization */}
          <script type="application/ld+json">
              {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "DataPulse AI",
              "url": "https://www.mydatapulse.co.uk",
              "logo": "https://www.mydatapulse.co.uk/logo-clean-large.png",
              "description": "Free up time and scale your business smarter with automation and AI - fully managed by DataPulse AI. No hiring, no tech hassle, no learning curve. Just results.",
              "sameAs": [
                  "https://www.linkedin.com/company/mydatapulse",
              ]
              })}
          </script>
      </Helmet>

      <div
        style={{
          height: '105vh',
          width: '100vw',
          overflowY: 'scroll',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor:"#040825",
        }}
        >
        <section id="aria-grace-network" className="flex-1 flex items-start h-screen w-screen justify-center">
          <div className="max-w-screen-xl px-4 pt-4 text-center">
            <div className="mx-auto text-center">
              <h2 style={{ color: '#E8FBCC' }} className="mb-1 text-3-5xl tracking-tight poppins-semibold">{title}</h2>
              <p style={{ color: '#F7FEEC' }} className="mb-3 text-xl poppins-extralight">
                How would you like to stay in touch?
              </p>
            </div>
            <div className="space-y-3 sm:grid sm:grid-cols-3 sm:gap-6 xl:gap-10">
            {linkCards.map((card) => (

            <a
                key={card.title}
                href={card.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-row lg:max-w-sm mx-auto items-center gap-4 p-3 text-left border dark:border-gray-600 rounded-lg shadow transition"
                style={{ backgroundColor: "#35524A", borderColor: "#F7FEEC" }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#4C7B70")}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#35524A")}
                >
                <img src={card.icon} alt={`${card.title} icon`} className="w-12 h-12 object-contain" />
                <div>
                  <h3 style={{ color: "#E8FBCC"}} className="text-2xl poppins-semibold">{card.title}</h3>
                  <p style={{ color: "#F7FEEC"}} className="text-gray-500 dark:text-gray-400 text-l poppins-extralight">{card.description}</p>
                </div>
              </a>
            ))}
            <h3 style={{ fontSize: "2.5rem", paddingTop: "1.5rem", paddingBottom: "0.35rem", lineHeight:"0", color:"#E8FBCC" }} className="tracking-tight poppins-semibold">
              {user_details.full_name}
            </h3>
            <h4 style={{ fontSize: "1.15rem", paddingTop: "1.5rem", lineHeight:"0", color:"#F7FEEC" }} className="poppins-extralight">{user_details.position}</h4>

            {/* Homepage */}
            <a
              href={user_details.company_url}
              className="flex flex-col justify-between text-center transition"
            >
             <div
              style={{
                width: '100%',
                maxWidth: '400px',
                margin: '0 auto',
                padding: '0 2rem'
              }}
            >
              <img
                src={user_details.company_logo}
                alt="logo image"
                style={{
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  width: '60%',
                  height: 'auto',
                  paddingTop: '0.7rem'
                }}
              />
            </div>
            </a>
            </div>
            <a href="https://www.mydatapulse.co.uk/digital-connect">
            <div style={{ paddingTop:'15px', paddingBottom:"20px", display: 'flex', justifyContent: 'center' }}>
              <img
              src="/icons/digital_connect/5.png"
              alt="Digital Connect icon"
              style={{
                width: '100%',
                maxWidth: '300px',
                height: 'auto',
                display: 'block',
                margin: '0 auto',
                opacity: 0.6
              }}
            />
            </div>
            </a>
          </div>
        </section>
      </div>
    </>
  );
}

export default DigitalCard;
